/*
  Scroll reveal for homepage sections. Maranello theme.
 
  A section is held blank until it is FULLY in the viewport, waits
  HOLD_MS, then its heading and cards cascade in with a slight overshoot
  and tilt. Scroll back up past a section and it resets, so scrolling
  down again replays it.
 
  Delays are written directly onto each element as an explicit
  transition-delay in ms. The gap WIDENS as the cascade goes on, so it
  decelerates rather than ticking along at a flat rhythm.
 
  No section .liquid file is modified.
  Set REVEAL_DEBUG = true to log the delays it calculates.
*/
(function () {
  'use strict';
 
  var REVEAL_DEBUG = false;
 
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
 
  /* ---- dials ---- */
 
  // Gap between the first item and the second, in ms.
  var STAGGER_MS = 210;
 
  // How much the gap widens. 1 = flat rhythm. 1.25 = noticeably slowing.
  var CURVE = 1.25;
 
  // Nothing waits longer than this, however many items a grid has.
  var MAX_DELAY_MS = 1400;
 
  // Blank beat after the section is fully in view, before anything moves.
  var HOLD_MS = 0;
 
  // Reversing out is quicker than coming in. 0.4 = 40% of the in-delays.
  var OUT_SCALE = 0.4;
 
  // How far each card tilts before righting itself. 0 disables the wobble.
  var TILT_DEG = 0;
 
  // Fire once the section's top edge has risen above this fraction of
  // viewport height. 0.75 = the section is about a quarter visible.
  // Lower = fires later, higher = fires sooner.
  var TRIGGER = 0.75;
 
  // Sections starting above this fraction of viewport height on load are
  // left completely alone, so the hero is never hidden.
  var FOLD = 0.6;
 
  /* ---- ---- */
 
  var observer;
  var foldCutoff = null;
  var recollectTimer = null;
 
  var THRESHOLDS = [];
  for (var i = 0; i <= 20; i++) THRESHOLDS.push(i / 20);
 
  function delayFor(index) {
    return Math.min(MAX_DELAY_MS, Math.round(STAGGER_MS * Math.pow(index, CURVE)));
  }
 
  function targetsIn(section) {
    var targets = [];
 
    var heading = section.querySelector('.block-section-title-wrap');
    if (heading) targets.push(heading);
 
    var cards = section.querySelectorAll('.grid > .grid-item');
    for (var c = 0; c < cards.length; c++) targets.push(cards[c]);
 
    // Sections with no heading and no grid move as a single unit.
    if (targets.length === 0) targets.push(section);
 
    return targets;
  }
 
  function isReady(entry) {
    return entry.boundingClientRect.top <= window.innerHeight * TRIGGER;
  }
 
  function prime(section) {
    var targets = targetsIn(section);
    var delays = [];
 
    for (var i = 0; i < targets.length; i++) {
      var d = delayFor(i);
      delays.push(d);
 
      targets[i].classList.add('reveal-item');
      targets[i].style.transitionDelay = d + 'ms';
 
      // Alternate the tilt so neighbouring cards lean opposite ways.
      // That reads as wobble rather than as a uniform skew.
      if (TILT_DEG) {
        targets[i].style.setProperty(
          '--reveal-tilt',
          (i % 2 === 0 ? -TILT_DEG : TILT_DEG) + 'deg'
        );
      }
    }
 
    section._revealTargets = targets;
    section._revealDelays = delays;
    section._revealShown = false;
 
    if (REVEAL_DEBUG) console.log('[reveal] delays:', delays.join(', '));
  }
 
  function show(section) {
    var targets = section._revealTargets || [];
    var delays = section._revealDelays || [];
 
    for (var i = 0; i < targets.length; i++) {
      targets[i].style.transitionDelay = (delays[i] || 0) + 'ms';
      targets[i].classList.add('is-revealed');
    }
 
    section._revealShown = true;
  }
 
  function reset(section) {
    var targets = section._revealTargets || [];
    var delays = section._revealDelays || [];
    var last = targets.length - 1;
 
    for (var i = 0; i < targets.length; i++) {
      // Reverse order on the way out, and quicker, so it feels like the
      // cascade unwinding rather than a second slow animation.
      var d = Math.round((delays[last - i] || 0) * OUT_SCALE);
      targets[i].style.transitionDelay = d + 'ms';
      targets[i].classList.remove('is-revealed');
    }
 
    section._revealShown = false;
  }
 
  observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var section = entry.target;
 
        // Fully out of view. Reset so scrolling back down replays it.
        if (!entry.isIntersecting) {
          window.clearTimeout(section._revealTimer);
          if (section._revealShown) reset(section);
          return;
        }
 
        if (section._revealShown || !isReady(entry)) return;
 
        window.clearTimeout(section._revealTimer);
        section._revealTimer = window.setTimeout(function () {
          show(section);
        }, HOLD_MS);
      });
    },
    { threshold: THRESHOLDS }
  );
 
  function collect() {
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    var scrollY = window.pageYOffset;
 
    if (foldCutoff === null) foldCutoff = window.innerHeight * FOLD;
 
    for (var s = 0; s < sections.length; s++) {
      var section = sections[s];
      if (section.dataset.revealReady === 'true') continue;
      section.dataset.revealReady = 'true';
 
      // Document-absolute top, correct at any scroll position.
      if (section.getBoundingClientRect().top + scrollY < foldCutoff) continue;
 
      prime(section);
      observer.observe(section);
    }
  }
 
  function recollect() {
    window.clearTimeout(recollectTimer);
    recollectTimer = window.setTimeout(collect, 120);
  }
 
  function init() {
    collect();
    // Images settle after DOMContentLoaded and change every measurement.
    window.addEventListener('load', recollect);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  // Theme editor edits and `shopify theme dev` hot reload replace section
  // markup, which arrives without our classes. Show it at once.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section || !section.closest('#MainContent')) return;
    section.dataset.revealReady = 'true';
    var targets = targetsIn(section);
    for (var i = 0; i < targets.length; i++) {
      targets[i].classList.remove('reveal-item', 'is-revealed');
      targets[i].style.transitionDelay = '';
      targets[i].style.removeProperty('--reveal-tilt');
    }
  });
})();